import type { FullParcel } from '@coig/apm-api';
import { useIonViewWillEnter } from '@ionic/react';
import { useEffect, useRef, useState } from 'react';
import { PackageReceivedListElement } from './package/received/PackageReceivedListElement';
import { PackageSentListElement } from './package/sent/PackageSentListElement';

interface PackageListProps {
  type: 'sent' | 'received';
  fetchPackages: () => Promise<FullParcel[] | undefined>;
  filter: string;
  setFocusedCard: (el: HTMLIonCardElement) => void;
}
const packagesList: React.FC<PackageListProps> = ({ fetchPackages, filter, type, setFocusedCard }) => {
  const [packages, setPackages] = useState([] as FullParcel[]);
  const elementsRefs = useRef<HTMLIonCardElement[]>([]);

  const filterPackages = (packages: FullParcel[] | undefined, filter: string) => {
    return packages?.filter((pck) => pck.parcelName.search(filter) !== -1);
  };

  const checkFilter = (element: FullParcel) => {
    if (filter.trim().length > 0) {
      return RegExp(filter.trim(), 'gim').test(element.parcelName);
    }
    return true;
  };

  useIonViewWillEnter(async () => {
    const fetchedPackages = await fetchPackages();
    const filteredPackages = filterPackages(fetchedPackages, filter);
    if (filteredPackages) {
      setPackages(filteredPackages);
    }
  });

  useEffect(()=>{
    let minDistance = 0;
    let nearestCard: HTMLIonCardElement | null = null;
    elementsRefs.current.forEach((el)=> {
      const distance = Math.abs(el.getBoundingClientRect().top);
      if (distance < minDistance || !nearestCard){
        minDistance = distance;
        nearestCard = el;
      }
    });
    if (nearestCard){
      setFocusedCard(nearestCard);
    }
  });

  return (
    <>{
      packages.map(
        (element, i) => {
          if (checkFilter(element)) {
            if (type === 'received') {
              return <PackageReceivedListElement {...element} key={element.id} ref={(el: HTMLIonCardElement) => elementsRefs.current[i] = el} />;
            } else {
              return <PackageSentListElement {...element} key={element.id} ref={(el: HTMLIonCardElement) => elementsRefs.current[i] = el}/>;
            }
          }
        })
    }</>
  );
};

export { packagesList as PackagesList };
